export default __webpack_public_path__ + "static/media/holdings_structure.c878a421.png";